import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'zone.js';

//New code for ang 10 was commented
// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

 var appConfig: any = window["appConfig"];
 if (appConfig && appConfig.angularProdMode) {
     enableProdMode();
 }

 platformBrowserDynamic().bootstrapModule(AppModule);
